<template>
  <FileUpload name="demo[]" accept="image/*,application/json" @select="onSelectedFiles">
    <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
      <div v-if="files.length > 0">
          <div v-for="(file) of files" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
            <span class="font-semibold">{{ file.name }}</span>
            <div>
              <Badge v-if="fileUploaded" value="Completed" severity="success" />
              <Badge v-else-if="fileUploadError" value="Error" severity="danger" />
              <Badge v-else value="Pending" severity="warning" />
            </div>

          </div>
      </div>
    </template>
    <template #empty>
      <div class="fileUploader">
        <div class="icon-upload-border">
          <IconUploadTwo class="icon-upload" size="100" />
        </div>
        <p class="mt-4 mb-0" style="color:#334155;">Drop files here to upload.</p>
      </div>
    </template>
  </FileUpload>
</template>

<script setup>
import {ref} from "vue";
import {useMainStore, useSlidesStore} from "@/store/index.ts";
import {storeToRefs} from "pinia";

const props = defineProps({
  parentFolder: {
    type: String,
    required: true
  },
  space: {
    type: String,
    required: false,
    default: null
  },
  uploadDirectoryId: {
    type: String,
    required: false,
    default: null
  },
  maxFiles: {
    type: Number,
    required: false,
    default: null
  },
  options: {
    type: Object,
    default: () => ({})
  },
  replaceFileId: {
    type: Number,
    required: false,
    default: null
  },
  breadcrumbItems: {
    type: Array,
    required: false
  }
})

const slidesStore = useSlidesStore()
const { valueModelId } = storeToRefs(slidesStore)
const mainStore = useMainStore()
const {slideLibraryActive} = storeToRefs(mainStore)
const tempFiles = ref({})


const fileUploaded = ref(false)
const fileUploadError = ref(false)
const emit = defineEmits(['file-uploaded']);
const concatBreadcrumbs = () => {
  const names = props.breadcrumbItems.filter(item => item.name !== 'Home').map(item => item.name);
  if (names.length === 0) {
    return '';
  }
  return '/' + names.join('/')
}




const optimisticSave = async (file) => {

  const { width, height } = await getImageDimensions(file);

  tempFiles.value = {
    resultsThumbnailImg: URL.createObjectURL(file),
    title: file.name,
    width: width,
    height: height
  }
  emit('temp-files', tempFiles.value)

  await saveFiles(file)
}

const getImageDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};


const saveFiles = async (file) => {
  console.log(file)
  const signedUrl = await getSignedURL(file, 'main', props.uploadDirectoryId, concatBreadcrumbs())
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', signedUrl);

  xhr.setRequestHeader('Content-Type', file.type);
  try {
    await new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(new Error('Failed to upload'));
        }
      };
      xhr.onerror = () => reject(new Error('Failed to upload'));
      xhr.send(file);
      fileUploaded.value = true
      emit('file-uploaded')
    });
  } catch (error) {
    fileUploadError.value = true
    console.error('Error:', error);
  }
};

const onSelectedFiles = async (event) => {
  await optimisticSave(event.files[0])
};

const getSignedURL = async (file, space, currentFolder, breadcrumbItems) => {

  const url = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/job-service/create-signed-url-and-job`;
  const data = {
    eventType: 'file-service-upload',
    filePath: file.name,
    contentType: file.type,
    jobDetails: {
      space: space,
      currentFolder: currentFolder,
      s3Prefix: breadcrumbItems,
      filePath: file.name,
      vmId: slideLibraryActive.value ? "null" : valueModelId.value
    }
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      console.error("Failed to send data:", response.statusText);
    }

    const parsedResponse = await response.json();
    return parsedResponse.putEndpoint;
  } catch (error) {
    console.error("Error sending data:", error);
    throw new Error('/');
  }
}

</script>

<style scoped>
:deep(.p-fileupload-buttonbar) {
  display: none;
}

:deep(.fileUploader) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


:deep(.icon-upload) {
  color: #94a3b8;
}

:deep(.icon-upload-border) {
  border: 1px solid #94a3b8;
  border-radius: 50%;
  padding: 20px;
}
</style>
